var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',[_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('h1',[_vm._v("Estamos Trabajando")])]),_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('el-image',{attrs:{"src":_vm.src}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }